export default "__VITE_ASSET__dc4aab21__"